module.exports = __webpack_public_path__ + "img/couponCenter.f3f426c9.png";